import { render, staticRenderFns } from "./RecentlyViewedBlock.vue?vue&type=template&id=9edce898&"
import script from "./RecentlyViewedBlock.vue?vue&type=script&lang=js&"
export * from "./RecentlyViewedBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSwiperCarousel: require('/app/components/UI/UiSwiperCarousel.vue').default})
